import { GetArrayTxtIndex } from './formaterTxt.js';
import FileSaver from 'file-saver';
import CryptoJS from 'crypto-js'
import imageCompression from 'browser-image-compression';
import { CreateHash } from './formaterBanner'
import { ObjectToHtml, base64ToBlob } from './formaterBanner';
import { getAsset, getOriginalAsset, generateUUID} from './assets';

export async function SaveReanimateFile(newMaster, assets, newListaReplicas = null, save = true) {
  try {
    let master = JSON.parse(JSON.stringify(newMaster));
    console.log('master antes', newMaster)
    console.log('master depois', master)
    let listaReplicas = JSON.parse(JSON.stringify(newListaReplicas));
    console.log('listaReplicas antes', newListaReplicas)
    console.log('listaReplicas depois', listaReplicas)
    console.log('assets antes', JSON.parse(JSON.stringify(assets)))
    try {
      if (!assets || assets.length === 0 || assets === null || assets === undefined || assets === "undefined") {
        assets = [];
        master.elements.forEach(element => {
          const index = assets.findIndex(obj => obj.uuid === element.properties.asset);
          if (index === -1) {
            if (element.properties.background) {
              assets.push({
                uuid: element.properties.asset,
                data: element.properties.background
              });
            } else if (element.properties.originalBackground) {
              assets.push({
                uuid: element.properties.asset,
                data: element.properties.originalBackground
              });
            } else if (element.properties.blob) {
              convertBlobToBase64(base64ToBlob(element.properties.blob)).then((b64) => {
                assets.push({
                  uuid: element.properties.asset,
                  data: b64
                });
              });
            }
          }
        });
  
        listaReplicas.forEach(replica => {
          replica.elements.forEach(element => {
            const index = assets.findIndex(obj => obj.uuid === element.properties.asset);
            if (index === -1) {
              if (element.properties.originalBackground) {
                assets.push({
                  uuid: element.properties.asset,
                  data: element.properties.originalBackground
                });
              } else if (element.properties.blob) {
                convertBlobToBase64(base64ToBlob(element.properties.blob)).then((b64) => {
                  assets.push({
                    uuid: element.properties.asset,
                    data: b64
                  });
                });
              } else if (element.properties.background) {
                assets.push({
                  uuid: element.properties.asset,
                  data: element.properties.background
                });
              }
            }
          });
        })
      }
    } catch (error) {
      console.log('Error ao processar assets com lista vazia', error);
    }
    console.log('assets depois', JSON.parse(JSON.stringify(assets)))

    master.html = "";
    const currentDate = new Date();
    const currentDayOfMonth = currentDate.getDate();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();
    const currentSeconds = currentDate.getSeconds();
    const dateString = `${currentYear}${currentMonth}${currentDayOfMonth}${currentHour}${currentMinutes}${currentSeconds}`;
    const fileName = `${master.name.replace(".rean", "")}_${dateString}.rean`;
    master.elements.forEach(element => {
      element.properties.background = "";
      element.properties.originalBackground = "";
    });
    let file = "<versao>" + master.versao +"</versao>";
    file += "<master>";
    file += JSON.stringify(master);
    file += "</master>";
    for (let i = 0; i < listaReplicas.length; i++) {
      let replica = listaReplicas[i];
      replica.elements.forEach(element => {
        element.properties.background = "";
        element.properties.originalBackground = "";
      });
      replica.html = "";
      file += "<replica>";
      file += JSON.stringify(replica);
      file += "</replica>";
    }
    
    file += "<assets>";
    file += JSON.stringify(assets);
    file += "</assets>";
    console.log('file', file)
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(file), '%G@g$#@FDcxzHJd234@#%').toString();
    const blob = new Blob([ciphertext], {type: "text/plain;charset=utf-8"});
    //SaveFileCookie(master, listaReplicas)
    if (save) FileSaver.saveAs(blob, fileName);
    else return blob;
  } catch (error) { console.log(error) }
}

export function convertBlobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function LoadReanimateFile(decryptFile) {
  var bytes = CryptoJS.AES.decrypt(decryptFile, '%G@g$#@FDcxzHJd234@#%');
  var file = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const masterSaved = GetArrayTxtIndex("<master>", "</master>", file, false, false);
  const replicasSaved = GetArrayTxtIndex("<replica>", "</replica>", file, false, false);
  let listAssets = GetArrayTxtIndex("<assets>", "</assets>", file, false, false);
  listAssets = listAssets.length ? JSON.parse(listAssets[0]) : [];
  listAssets = !listAssets ? [] : listAssets;
  const masterObject = JSON.parse(masterSaved[0]); 
  var hash = ""; 
  if (!masterObject.hash || masterObject.hash === "") {
    hash = CreateHash(masterObject);
    masterObject.hash = hash;
  }
  
  for (var j = 0; j < masterObject.elements.length; j++) {
    if (masterObject.elements[j].properties.asset) {
      masterObject.elements[j].properties.background = await getAsset(listAssets, masterObject.elements[j].properties.asset, masterObject.optimize);
      masterObject.elements[j].properties.originalBackground = getOriginalAsset(listAssets, masterObject.elements[j].properties.asset);
    } else {
        const uuid = generateUUID();
        listAssets.push({
          uuid: uuid,
          data: masterObject.elements[j].properties.originalBackground
        });
        masterObject.elements[j].properties.asset = uuid;
        masterObject.elements[j].properties.background = await getAsset(listAssets, masterObject.elements[j].properties.asset, masterObject.optimize);
        masterObject.elements[j].properties.originalBackground = getOriginalAsset(listAssets, masterObject.elements[j].properties.asset);
    }
    const blob = base64ToBlob(masterObject.elements[j].properties.originalBackground);
    const blobUrl = URL.createObjectURL(blob);
    masterObject.elements[j].properties.blob = blobUrl;
  }

  console.log(masterObject.elements)

  masterObject.html = ObjectToHtml(masterObject, true);

  const listarReplicasSaved = [];
  for (var i = 0; i < replicasSaved.length; i++) {
    try {
      const repl = JSON.parse(replicasSaved[i]);
      for (var j = 0; j < repl.elements.length; j++) {
        if (repl.elements[j].properties.asset) {
          repl.elements[j].properties.background = await getAsset(listAssets, repl.elements[j].properties.asset, repl.optimize);
          repl.elements[j].properties.originalBackground = getOriginalAsset(listAssets, repl.elements[j].properties.asset);
        } else {
          const index = masterObject.elements.findIndex(obj => obj.id === repl.elements[j].id);
          if (index !== -1) {
            repl.elements[j].properties.asset = masterObject.elements[index].properties.asset;
          } else {
            const uuid = generateUUID();
            listAssets.push({
              uuid: uuid,
              data: repl.elements[j].properties.originalBackground
            });
            repl.elements[j].properties.asset = uuid;
          }
          repl.elements[j].properties.background = await getAsset(listAssets, repl.elements[j].properties.asset, repl.optimize);
          repl.elements[j].properties.originalBackground = getOriginalAsset(listAssets, repl.elements[j].properties.asset);
        }
        const blob = base64ToBlob(repl.elements[j].properties.originalBackground);
        const blobUrl = URL.createObjectURL(blob);
        repl.elements[j].properties.blob = blobUrl;
      }
      repl.html = await ObjectToHtml(repl, true);
      if (hash !== "") repl.hash = hash;
      listarReplicasSaved.push(repl);
    } catch {}
  }
  
  return {"master": masterObject, "listaReplicas": listarReplicasSaved, "assets": listAssets};
}

export function ClearCookies() {
  localStorage.setItem('@reanimate/project', "");
}

export async function Compress(background, quality) {
  var ext = "png";
  try {
    ext = background.split(";base64")[0].replace("data:image/","");
  } catch { }
  var file = await urltoFile(background, 'hello.${ext}',`image/${ext}`);
  var options = {
    initialQuality: quality / 100
  };
  var image = await imageCompression(file, options);
  var b64 = await blobToBase64(image);
  return b64;
}

function urltoFile(url, filename, mimeType){
  return (fetch(url)
      .then(function(res){return res.arrayBuffer();})
      .then(function(buf){return new File([buf], filename,{type:mimeType});})
  );
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export function GetBannerSize(html) {
  var myblob = new Blob([html], {
      type: 'text/plain'
  });
  return (myblob.size / 1024).toFixed(0);
}
